export default __webpack_public_path__ + "static/main-secondary03-329c58ede67a56d114a7e99d7f37cbde.jpg";